<template>
	<div>
		<AlertGroup class="fixed left-4 right-4 top-4" />
		<slot />
	</div>
</template>
<script setup lang="ts">
import AlertGroup from '../components/AlertGroup.vue'
</script>
